$("a.modal-button, a.video-modal-link, a[rel*='lightbox']").click(function modal(e) {
  var vidID;
  var $this = $(this);
  var href = $this.attr("href");
  var $content = $("div");
  var options = {
    beforeOpen: function bop() {
      $(".page-container").addClass("grayscale");
    },
    beforeClose: function bcl() {
      $(".page-container").removeClass("grayscale");
    },
    afterClose: function acl() {
      setTimeout(function ac() {
        $this.blur();
      }, 0);
    }
  };

  e.preventDefault();

  if (href.match(/youtube\.com|youtu\.be/gi)) {
    vidID = /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_\-]+)/.exec(href)[1];
    if ($(window).width() < 768) {
      window.open(href);
      return;
    } else {
      eURL = location.protocol + "//www.youtube.com/embed/" + vidID + "?autohide=1&modestbranding=1&start=0&rel=0&autoplay=1";
      $content = $("<iframe src=\"" + eURL + "\" frameborder=\"0\" width=\"978\" height=\"550\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>");
    }
    options.persist = true;
    $.featherlight($content, options);
  } else if (href.indexOf(".mp4") >= 0) {
    $content = $("<video class=\"full-width\" preload=\"auto\" autoplay=\"autoplay\" controls=\"true\"><source src=\"" + $this.attr("href") + "\" type=\"video/mp4\"></video>");
  } else if (href.match(/\.(jpg|gif|png|svg)/gi)) {
    $content = $("<img class=\"full-width\" src=\"" + href + "\" />");
    options.persist = true;
    $.featherlight($content, options);
  } else if (href.match(/^\//gi)) {
    if ($("body").hasClass("samadmin")) {
      location.href = href;
    } else {
      options.type = "ajax";
      $.featherlight(href + " main", options);
    }
  } else if (href.indexOf("#") === 0) {
    $.featherlight(href, options);
    return false;
  } else {
    options.iframe = href;
    options.iframeWidth = 800;
    options.iframeHeight = 600;
    $.featherlight(options);
  }
  // } else if (href.match(/default\.asp|\/pages\//gi)) {
  //   location.href = href;
});
